import { render, staticRenderFns } from "./SupplierPage.vue?vue&type=template&id=17b8ff2d&scoped=true"
import script from "./SupplierPage.vue?vue&type=script&lang=js"
export * from "./SupplierPage.vue?vue&type=script&lang=js"
import style0 from "./SupplierPage.vue?vue&type=style&index=0&id=17b8ff2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b8ff2d",
  null
  
)

export default component.exports